import { FC, useEffect } from 'react';
import * as toast from 'utils/toast';
import { product } from 'copy/copy';

/*
This component allows activation of toast messages for development and testing purposes.

Key Commands:
shift+alt+E: Error Toast
shift+alt+I: Info Toast
shift+alt+S: Success Toast
*/

const Toaster: FC = () => {
  const toastText = {
    offline: {
      title: 'No Internet Connection Found',
      message: `Please check your connection to continue using ${product.productName}.`,
    },
  };

  useEffect(() => {
    const handleKeypress = (evt: KeyboardEvent) => {
      if (evt.shiftKey !== true || evt.altKey !== true) return;

      switch (evt.code) {
        // shift+alt+E
        case 'KeyE':
          toast.error('This is a test error toast');
          break;

        // shift+alt+I
        case 'KeyI':
          toast.info('This is a test info toast');
          break;

        // shift+alt+S
        case 'KeyS':
          toast.success('This is a test success toast');
          break;

        // shift+alt+O
        case 'KeyO':
          toast.offline(toastText);
          break;
        default:
      }
    };

    window.addEventListener('keypress', handleKeypress);

    return () => {
      window.removeEventListener('keypress', handleKeypress);
    };
  }, []);

  return null;
};

export default Toaster;
